export const phoneMask = [
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];
export const zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const numberMask = (rawValue) => [...rawValue].map(() => /\d/);
